import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/v2_live/icomm/app/(dashboard)/campaigns/page.tsx");
